import React from 'react';

/** @internal */
export var calendarIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "26",
  height: "25",
  viewBox: "0 0 26 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9375 2.33594H2.0625C1.19961 2.33594 0.5 3.03555 0.5 3.89844V23.4297C0.5 24.2926 1.19961 24.9922 2.0625 24.9922H23.9375C24.8004 24.9922 25.5 24.2926 25.5 23.4297V3.89844C25.5 3.03555 24.8004 2.33594 23.9375 2.33594ZM2.0625 3.89844H23.9375V23.4297H2.0625V3.89844Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.86938 4.6875C9.86938 5.11953 9.51978 5.46914 9.08813 5.46914C8.65649 5.46914 8.30688 5.11953 8.30688 4.6875V0.781641C8.30688 0.349609 8.65649 0 9.08813 0C9.51978 0 9.86938 0.349609 9.86938 0.781641V4.6875Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6819 4.6875C17.6819 5.11953 17.3327 5.46914 16.9006 5.46914C16.469 5.46914 16.1194 5.11953 16.1194 4.6875V0.781641C16.1194 0.349609 16.469 0 16.9006 0C17.3327 0 17.6819 0.349609 17.6819 0.781641V4.6875Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0312 9.37109H18.4688C18.0371 9.37109 17.6875 9.7207 17.6875 10.1523V11.7148C17.6875 12.1461 18.0371 12.4961 18.4688 12.4961H20.0312C20.4629 12.4961 20.8125 12.1461 20.8125 11.7148V10.1523C20.8125 9.7207 20.4629 9.37109 20.0312 9.37109Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0312 15.6211H18.4688C18.0371 15.6211 17.6875 15.9707 17.6875 16.4023V17.9648C17.6875 18.3961 18.0371 18.7461 18.4688 18.7461H20.0312C20.4629 18.7461 20.8125 18.3961 20.8125 17.9648V16.4023C20.8125 15.9707 20.4629 15.6211 20.0312 15.6211Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7812 15.6211H12.2188C11.7871 15.6211 11.4375 15.9707 11.4375 16.4023V17.9648C11.4375 18.3961 11.7871 18.7461 12.2188 18.7461H13.7812C14.2129 18.7461 14.5625 18.3961 14.5625 17.9648V16.4023C14.5625 15.9707 14.2129 15.6211 13.7812 15.6211Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7812 9.37109H12.2188C11.7871 9.37109 11.4375 9.7207 11.4375 10.1523V11.7148C11.4375 12.1461 11.7871 12.4961 12.2188 12.4961H13.7812C14.2129 12.4961 14.5625 12.1461 14.5625 11.7148V10.1523C14.5625 9.7207 14.2129 9.37109 13.7812 9.37109Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.53125 9.37109H5.96875C5.53711 9.37109 5.1875 9.7207 5.1875 10.1523V11.7148C5.1875 12.1461 5.53711 12.4961 5.96875 12.4961H7.53125C7.96289 12.4961 8.3125 12.1461 8.3125 11.7148V10.1523C8.3125 9.7207 7.96289 9.37109 7.53125 9.37109Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.53125 15.6211H5.96875C5.53711 15.6211 5.1875 15.9707 5.1875 16.4023V17.9648C5.1875 18.3961 5.53711 18.7461 5.96875 18.7461H7.53125C7.96289 18.7461 8.3125 18.3961 8.3125 17.9648V16.4023C8.3125 15.9707 7.96289 15.6211 7.53125 15.6211Z"
}));